define(["require", "exports", "jquery", "./designbook", "./renderCustomValance", "./context", "./addressBar", "./assetPicker", "./addressBar", "./priceFormula", "./ajaxCart", "./curtainSizeSpec", "./number", "./renderCustomValance", "./slideSelect", "./settings", "./analytics", "./assetFilter", "./selectSpinner", "./productImages", "./fallbackMatchingFabric"], function (require, exports, $, designbook_1, renderCustomValance_1, context_1, addressBar_1, assetPicker_1, addressBar_2, priceFormula_1, ajaxCart_1, curtainSizeSpec_1, number_1, renderCustomValance_2, slideSelect_1, settings_1, analytics_1, assetFilter_1, selectSpinner_1, productImages_1, fallbackMatchingFabric_1) {
    "use strict";
    exports.__esModule = true;
    var PanelIndex;
    (function (PanelIndex) {
        PanelIndex[PanelIndex["measurement"] = 0] = "measurement";
        PanelIndex[PanelIndex["size"] = 1] = "size";
        PanelIndex[PanelIndex["style"] = 2] = "style";
        PanelIndex[PanelIndex["fabric"] = 3] = "fabric";
        PanelIndex[PanelIndex["fringe"] = 4] = "fringe";
        PanelIndex[PanelIndex["color"] = 5] = "color";
        PanelIndex[PanelIndex["sheer"] = 6] = "sheer";
        PanelIndex[PanelIndex["panelHeading"] = 7] = "panelHeading";
        PanelIndex[PanelIndex["pillow"] = 8] = "pillow";
        PanelIndex[PanelIndex["LAST"] = 9] = "LAST";
    })(PanelIndex || (PanelIndex = {}));
    function getPanelIndex() {
        var cur = parseFloat($('#customProgress').data('decimal'));
        if (isNaN(cur)) {
            cur = panelOrder[0];
        }
        return cur;
    }
    function setPanelIndex(panelIndex) {
        var curPanel = getPanelIndex();
        var $curPanel = $("#panel" + curPanel);
        if (curPanel != panelIndex && $curPanel.hasClass('bottom-panel')) {
            $curPanel.toggleClass('bottom-panel', false);
        }
        $('#customProgress').data('decimal', panelIndex);
        var $panel = $(panelNumber(panelIndex));
        $panel.toggleClass('bottom-panel', true);
        if (!context_1["default"].isMobile()) {
            if (panelIndex === panelOrder[0]) {
                $('.attributes > div:nth-of-type(n+2)').hide();
            }
            else {
                $('.attributes > div:nth-of-type(n+2)').show();
            }
        }
        else {
            var $secondFabricSection = $('#matchingFabricSection');
            var onSecondFabricPanel = panelIndex === 3.5;
            $secondFabricSection.toggleClass('current', onSecondFabricPanel).toggleClass('hidden', !onSecondFabricPanel);
            if (onSecondFabricPanel) {
                $secondFabricSection.prev().toggleClass('hidden', true);
            }
            else if (panelIndex === PanelIndex.fabric) {
                $secondFabricSection.prev().toggleClass('hidden', false);
            }
        }
        return panelIndex;
    }
    function setRecommendedText() {
        var $width = $('#custom_recommended_width');
        var $height = $('#custom_recommended_height');
        if (idealWidth) {
            $width.text(idealWidth + " inch");
            $width.parent().toggleClass('hidden', false);
        }
        else {
            $width.parent().toggleClass('hidden', true);
        }
        if (idealHeight) {
            $height.text(idealHeight + " inch");
            $height.parent().toggleClass('hidden', false);
        }
        else {
            $height.parent().toggleClass('hidden', true);
        }
    }
    function useCustomSize() {
        return $('#useCustomSize').val() == 1;
    }
    function skipWindowMeasurement() {
        return number_1.extractFieldAsDecimal($('#skipWindowMeasurement')) === 1;
    }
    function onWindowMeasureXUpdated(e) {
        var windowWidth = $('#windowWidth').val();
        var leftMargin = $('#leftMargin').val();
        var rightMargin = $('#rightMargin').val();
        if (windowWidth && leftMargin && rightMargin) {
            idealWidth = windowWidth * 1 + Math.min(leftMargin, 6) * 1 + Math.min(rightMargin, 6) * 1;
            idealWidth = Math.round(idealWidth / 5) * 5;
            if (!useCustomSize()) {
                $('#drapeWidth').data('decimal', idealWidth).val(idealWidth);
            }
            setRecommendedText();
        }
        return idealWidth;
    }
    function onWindowMeasureYUpdated(e) {
        var windowHeight = $('#windowHeight').val();
        var topMargin = $('#topMargin').val();
        var bottomMargin = $('#bottomMargin').val();
        if (windowHeight && topMargin && bottomMargin) {
            idealHeight = Math.ceil(windowHeight * 1 + bottomMargin * 1 + Math.min(topMargin / 2, 12) * 1);
            if (!useCustomSize()) {
                $('#drapeHeight').data('decimal', idealHeight).val(idealHeight);
            }
            setRecommendedText();
        }
        return idealHeight;
    }
    function panelNumber(i) {
        return ("#panel" + i).replace(".", "-");
    }
    var canProceedToNextPanel = function (panelIndex) { return true; };
    var panelOrder = [
        PanelIndex.style,
        PanelIndex.fabric,
        PanelIndex.fringe,
        PanelIndex.color,
        PanelIndex.size,
        PanelIndex.panelHeading,
        PanelIndex.sheer,
        PanelIndex.pillow
    ];
    function onClickNextInner(e) {
        var inputPanelNumber = getPanelIndex();
        var orderIndex = panelOrder.indexOf(Math.floor(inputPanelNumber));
        if (panelNumber(Math.floor(inputPanelNumber) + 1) == "#picker_fabricId") {
            if (!($("#picker_fabricId")[0])) {
                return;
            }
            else if ($(".panel-close")[0]) {
                $('.panel-close').replaceWith("<div class='form-row'><button type='button' class='prev-section' id='fabricPanelPrev'>prev</button><button type='button' class='next-section' id='fabricPanelNext'>next</button></div>");
                $('#fabricPanelNext').click(onClickNext);
                $('#fabricPanelPrev').click(onClickPrev);
            }
        }
        if (!canProceedToNextPanel(inputPanelNumber)) {
            return;
        }
        if (inputPanelNumber === PanelIndex.measurement) {
            if (skipWindowMeasurement()) {
                $("#panel" + PanelIndex.measurement).toggleClass('bottom-panel', false);
                useDefaultWindowSize();
                return;
            }
            useCustomWindowSize();
        }
        if (inputPanelNumber === PanelIndex.fabric) {
            if ($('#second-fabric:checked').length) {
                onClickAdvanced(e);
                return;
            }
        }
        if (inputPanelNumber === PanelIndex.style) {
            $('#custom_style_select input').change();
        }
        var $prevPanel = $(panelNumber(inputPanelNumber));
        $prevPanel.toggleClass('bottom-panel', false);
        var $prevSection = $prevPanel.find('.sub-section');
        if ($prevSection.length === 0 && $prevPanel.hasClass('expanded')) {
            $prevSection = $prevPanel;
        }
        $prevSection.toggleClass('expanded', false).toggleClass('collapsed', true);
        var nextPanelIndex = orderIndex < panelOrder.length - 1 ? panelOrder[orderIndex + 1] : PanelIndex.LAST;
        if (nextPanelIndex === PanelIndex.panelHeading && !curtainSizeSpec_1.hasPanel(getCurrentProductType(true))) {
            nextPanelIndex = PanelIndex.sheer;
        }
        inputPanelNumber = setPanelIndex(nextPanelIndex);
        var $panel = $(panelNumber(inputPanelNumber));
        var $subsection = $panel.find('.sub-section');
        if (!$subsection.length && $panel.hasClass('collapsed')) {
            $subsection = $panel;
        }
        $subsection.toggleClass('collapsed', false).toggleClass('expanded', true);
        selectDefaultSlideSelectBox($panel);
        if (inputPanelNumber === PanelIndex.fabric && !number_1.extractFieldAsDecimal($('input[data-attribute-name="fabricId"]'))) {
            $panel.prev().find('.show-picker-action').click();
        }
        analytics_1["default"]('customize', 'nextPanel', PanelIndex[inputPanelNumber]);
        var $productTypeField = $('#custom_product_select input[type="hidden"]');
        if (inputPanelNumber === PanelIndex.style) {
            if ($productTypeField.data('decimal') === null) {
                slideSelect_1.setRadioSelect($('#custom_product_select'), renderCustomValance_1.ProductType.FullSet);
                $productTypeField.data('decimal', renderCustomValance_1.ProductType.FullSet);
                $productTypeField.change();
            }
            if (!context_1["default"].isMobile()) {
                var top_1 = $("#panel" + inputPanelNumber).parent().offset().top;
                var headerTop = $('.header').height();
                var curY = window.scrollY;
                window.scrollBy(0, top_1 - headerTop - curY);
            }
        }
        else if (inputPanelNumber === PanelIndex.size) {
            $productTypeField.change();
        }
        setUrl();
        updateDescriptions();
    }
    function onClickNext(e) {
        onClickNextInner(e);
        if (!context_1["default"].isMobile()) {
            var showMatchingFabric = $('#second-fabric:checked').length > 0;
            var shownMatchingFabric = $('#matchingFabricSection:visible').length > 0;
            var fabricId = priceFormula_1.getAttributesFromForm().fabricId;
            if (fabricId > 0 && showMatchingFabric !== shownMatchingFabric) {
                $('#second-fabric').trigger('change');
            }
        }
    }
    exports.onClickNext = onClickNext;
    function onClickPrev(e) {
        var inputPanelNumber = getPanelIndex();
        var orderIndex = panelOrder.length - 1;
        orderIndex = panelOrder.indexOf(Math.ceil(inputPanelNumber));
        $(panelNumber(inputPanelNumber)).toggleClass('bottom-panel', false);
        if (inputPanelNumber === PanelIndex.fringe && $('#second-fabric:checked').length) {
            inputPanelNumber = setPanelIndex(Math.ceil(inputPanelNumber) - 0.5);
        }
        else {
            inputPanelNumber = orderIndex > 0 ? panelOrder[orderIndex - 1] : panelOrder[0];
            if (inputPanelNumber === PanelIndex.panelHeading && !curtainSizeSpec_1.hasPanel(getCurrentProductType(true))) {
                inputPanelNumber = PanelIndex.size;
            }
            inputPanelNumber = setPanelIndex(inputPanelNumber);
        }
        analytics_1["default"]('customize', 'prevPanel', PanelIndex[inputPanelNumber]);
        setUrl();
        updateDescriptions();
    }
    function onClickAdvanced(e) {
        var inputPanelNumber = getPanelIndex();
        $(panelNumber(inputPanelNumber)).toggleClass('bottom-panel', false);
        analytics_1["default"]('customize', 'advancedPanel', PanelIndex[inputPanelNumber]);
        inputPanelNumber += 0.5;
        setPanelIndex(inputPanelNumber);
        setUrl();
    }
    function onChangeRenderingParameters() {
        renderCustomValance_1.renderPictures(true, styleIndex, renderType);
    }
    var defaultWindowMeasure = {
        windowWidth: 60,
        windowHeight: 64,
        leftMargin: 20,
        rightMargin: 20,
        topMargin: 24,
        bottomMargin: 20
    };
    function setWindowMeasurements(m) {
        Object.keys(m).forEach(function (k) {
            number_1.setFieldNumberVal($("#" + k), m[k]);
        });
    }
    function getWindowMeasurements() {
        var measures = Object.keys(defaultWindowMeasure).map(function (k) {
            var p = {};
            p[k] = $("#" + k).val();
            return p;
        });
        return measures.reduce(function (m, cur) { return $.extend(m, cur); }, {});
    }
    function setUrl() {
        var data = priceFormula_1.getAttributesFromForm(false, getCurrentProductType());
        addressBar_2.setHashFromData(data);
        return data;
    }
    function addCustomOrderToCart(e) {
        e.preventDefault();
        analytics_1["default"]('cart', 'addProduct');
        var actionUrl = "/ShoppingCart/AddFormulaProductsToCart?productVariantId=0&shoppingCartType=1";
        var postData = { forceCartItemImageUrl: true };
        var data = priceFormula_1.getAttributesFromForm(false, getCurrentProductType());
        var fringeColor = data['frg'] || data['fringeColor'];
        data['hasFringe'] = fringeColor ? 1 : 0;
        data['fabricDiscount'] = 0.0;
        postData['add_to_cart_formula_full_customization'] = $.param(data);
        var xhr = ajaxCart_1.AjaxCart.instance().addProductVariantsToCart(actionUrl, postData, null);
        if (settings_1._settings.renderCartImage) {
            xhr.then(renderCustomValance_2.tryRenderCartImage)
                .then(function (cartImageFile) {
                if (cartImageFile) {
                    ajaxCart_1.AjaxCart.instance().addProductVariantsToCart(actionUrl, postData, cartImageFile);
                }
            });
        }
    }
    function publishDesignBook(e) {
        e.preventDefault();
        designbook_1.showShareActionSheet(true);
    }
    exports.publishDesignBook = publishDesignBook;
    function getClosedPanelDescriptionSpan(panelIndex) {
        var $panel = $("#panel" + panelIndex);
        var $infoButton = $panel.find('.info-bar button');
        var $span = $infoButton.next('span');
        if (!$span.length) {
            $span = $('<span></span>').insertAfter($infoButton);
        }
        return $span;
    }
    function isPanelClosed(panelIndex) {
        return $("#panel" + panelIndex + " .sub-section.collapsed").length > 0;
    }
    var windowMeasurementLabel = {
        windowWidth: 'W',
        windowHeight: 'H',
        leftMargin: 'Left',
        rightMargin: 'Right',
        bottomMargin: 'Bottom',
        topMargin: 'Top'
    };
    function windowSizeDescription() {
        if (skipWindowMeasurement()) {
            return 'N/A';
        }
        var measures = $.map(Object.keys(defaultWindowMeasure), function (k, i) {
            var $fld = $("#" + k);
            var val = number_1.extractFieldAsDecimal($fld);
            return windowMeasurementLabel[k] + ": " + val + "\"";
        });
        return measures.join(', ');
    }
    function updateDescriptions() {
        var data = priceFormula_1.getAttributesFromForm(false, getCurrentProductType());
        var windowMeasured = hasValidWindowMeasurements();
        var showWorksheet = !skipWindowMeasurement();
        var $worksheet = $('#panel0 .worksheet');
        var $range = $worksheet.find('.size-range');
        $worksheet.toggleClass('hidden', !showWorksheet);
        var curPanel = getPanelIndex();
        if (curPanel == PanelIndex.measurement && showWorksheet) {
            hidePageHeader();
        }
        else {
            showPageHeader();
        }
        if ($range.hasClass('hidden') && showWorksheet) {
            $range.toggleClass('hidden', !showWorksheet);
            var $radio = $worksheet.find('input[name="windowSizeEdit"][value="windowWidth"]');
            $radio.prop('checked', 'checked');
            $radio.next('label').trigger('click');
        }
        if (data.customProgress !== undefined) {
            if (data.customProgress !== PanelIndex.measurement) {
                $("#panel" + PanelIndex.measurement + " .sub-section").toggleClass('collapsed', true).toggleClass('expanded', false);
            }
            if (data.customProgress !== PanelIndex.size) {
                $("#panel" + PanelIndex.size + " .sub-section").toggleClass('collapsed', true).toggleClass('expanded', false);
            }
            if (data.customProgress !== PanelIndex.style) {
                $("#panel" + PanelIndex.style).toggleClass('collapsed', true).toggleClass('expanded', false);
            }
            $("#panel" + data.customProgress + " .sub-section").toggleClass('collapsed', false).toggleClass('expanded', true);
            if (data.customProgress === PanelIndex.size) {
                if (data.useCustomSize) {
                    if (context_1["default"].isMobile()) {
                        var $radio = $("#panel" + PanelIndex.size + " input[name=\"curtainSizeEdit\"]:checked");
                        if ($radio.length === 0) {
                            $radio = $("#panel" + PanelIndex.size + " input[name=\"curtainSizeEdit\"][value=\"drapeWidth\"]");
                            $radio.prop('checked', 'checked');
                            $radio.next('label').trigger('click');
                        }
                    }
                }
            }
        }
        if (data.panelHeading) {
            var $panel = $("#panel" + PanelIndex.panelHeading);
            var $cur = $panel.find('.info-bar .selected');
            if ($panel.find('.sub-section').hasClass('collapsed')) {
                var $selected = $panel.find('.slide-select button.selected');
                var texts = $.map($selected, function (s) { return $(s).text().trim() || $(s).attr('title'); });
                $cur.text(texts.join(' & '));
            }
            else {
                $cur.empty();
                var ids = $panel.find('.slide-select').map(function (_i, s) { return $(s).attr('id'); });
                for (var i = 0; i < ids.length; i++) {
                    var id = ids[i];
                    var $label = $panel.find("label[for='" + id + "']");
                    var $selected = $panel.find("#" + id + " button.selected");
                    var selectedText = $selected.text().trim() || $selected.attr('title');
                    var labelText = $label.text().trim();
                    var labelPrefix = labelText.substring(0, labelText.indexOf(':'));
                    $label.text(labelPrefix + ": " + selectedText);
                }
            }
            ;
        }
        if (data.pillowCount) {
            var $panel = $("#panel" + PanelIndex.pillow);
            var $cur = $panel.find('.info-bar .selected');
            if ($panel.find('.sub-section').hasClass('collapsed')) {
                $cur.text($panel.find('select').val());
            }
            else {
                $cur.empty();
            }
        }
        var $sheerLabel = $('label[for="custom_sheerSelect"]');
        if (data.sheerGrade === 0) {
            $sheerLabel.text('');
        }
        else {
            $sheerLabel.text("" + $('#custom_sheerSelect .selected label').text());
        }
        if (data.wallColor) {
            $("#panel" + PanelIndex.color + " .info-bar .selected .color-block").css({ 'background-color': renderCustomValance_1.wallColor_to_hex[data.wallColor] });
        }
        $('#useCustomSize').next('label').text(data.skipWindowMeasurement ? 'Use default size' : 'Use recommended size');
        if (true) {
            var showDescription = isPanelClosed(PanelIndex.measurement);
            var $span = getClosedPanelDescriptionSpan(PanelIndex.measurement);
            if (showDescription) {
                $span.text(windowSizeDescription());
            }
            else {
                $span.text('');
            }
        }
        if (data.width && data.height) {
            var showDescription = isPanelClosed(PanelIndex.size);
            var $span = getClosedPanelDescriptionSpan(PanelIndex.size);
            if (showDescription) {
                var _a = sizeFromProductData(data), width = _a.width, height = _a.height;
                if (width && height) {
                    $span.text(width + "\" W x " + height + "\" H");
                }
                else {
                    $span.text(width + "\" W");
                }
            }
            else {
                $span.text('');
            }
        }
    }
    var sizeFromProductData = function (data) {
        var productType = data.productType, width = data.width, height = data.height, panelWidth = data.panelWidth;
        return {
            width: productType === renderCustomValance_1.ProductType.DrapeOnly ? panelWidth : width,
            height: productType === renderCustomValance_1.ProductType.ValanceOnly ? undefined : height
        };
    };
    function onSpecChange(changed) {
        if (!validateFabricGrades()) {
            return;
        }
        var productType = getCurrentProductType();
        var data = priceFormula_1.getAttributesFromForm(false, productType);
        var currentStyle = styleIndex || data['styleIndex'];
        curtainSizeSpec_1.updateSizeSpecs($('div[data-sizeSpec'), currentStyle);
        if (!validateCurtainSize()) {
            return;
        }
        var mainFabric = data['fabricId'];
        var secondFabric = data['fabric2Id'];
        var $secondFabricId = $('input[data-attribute-name="fabric2Id"]');
        var $secondFabricCode = $('input[data-attribute-name="fabric2_CodeName"]');
        var $secondFabricGrade = $('input[data-attribute-name="fabric2Grade"]');
        var secondFabricGrade = 0;
        var useSecondFabric = function (fid, asMatching) {
            var useMainFabric = $('#second-fabric:checked').length === 0;
            if (useMainFabric) {
                data['fabric2Id'] = mainFabric;
                fid = mainFabric;
            }
            else {
                data['fabric2Id'] = fid;
            }
            if (asMatching && !useMainFabric) {
                $secondFabricId.data('using_matching', asMatching);
            }
            else {
                $secondFabricId.removeData('using_matching');
            }
            var prevFid = $secondFabricId.data('decimal');
            if (prevFid !== fid) {
                $secondFabricId.data('decimal', fid).val(fid);
                if (fid > 0) {
                    var $asset = $("img.asset[data-asset_id=\"" + fid + "\"]");
                    var codeName = $asset.attr('codename');
                    $secondFabricCode.val(codeName);
                    secondFabricGrade = $asset.data('asset_grade');
                }
                else {
                    $secondFabricCode.val("");
                }
                $secondFabricGrade.data('decimal', secondFabricGrade).val(secondFabricGrade);
                $secondFabricId.change();
                $secondFabricCode.change();
            }
        };
        var usingMatching = $secondFabricId.data('using_matching');
        if (renderCustomValance_1.styleNeedsMatchingFabric(currentStyle) && mainFabric > 0) {
            var matchingProductId = parseInt($("img.asset[data-asset_id=\"" + mainFabric + "\"]").data('matching_product_id'));
            if (!secondFabric || usingMatching) {
                useSecondFabric(matchingProductId, true);
            }
        }
        else if (secondFabric > 0 && usingMatching) {
            useSecondFabric(0, true);
        }
        setUrl();
        updateDescriptions();
        var sizeInfo = sizeFromProductData(data);
        var $infoContainer = $('.customizeAddCart');
        productImages_1.updateProductSizeInfo($infoContainer, sizeInfo);
        renderCustomValance_1.renderPictures(true, styleIndex, renderType);
        calculatePriceIfPossible();
    }
    exports.onCustomerSceneBackgroundChange = function () { return renderCustomValance_1.renderPictures(true, styleIndex, renderType); };
    function getNumberValue(val) {
        var _val = val * 1;
        return typeof (_val) === 'number' && !isNaN(_val) ? _val : undefined;
    }
    var styleIndexToFormula = {
        s1: 'PF-S1',
        s2: 'PF-S1',
        s3: 'PF-S1',
        s4: 'PF-S3-PelmetStyle',
        s5: 'PF-S1',
        s6: 'PF-S2-Plus',
        s7: 'PF-S2-Plus',
        s8: 'PF-S1',
        s9: 'PF-S2',
        s10: 'PF-SP',
        s11: 'PF-S2',
        s12: 'PF-S2-Plus',
        s13: 'PF-S3-PelmetStyle',
        s14: 'PF-S3-PelmetStyle',
        s15: 'PF-S3-PelmetStyle'
    };
    function getPriceForType(pricing, productType) {
        switch (productType) {
            case renderCustomValance_1.ProductType.DrapeOnly:
                return getNumberValue(pricing['panelCost']);
            case renderCustomValance_1.ProductType.FullSet:
                return getNumberValue(pricing['totalProductCost']);
            case renderCustomValance_1.ProductType.ValanceOnly:
                return getNumberValue(pricing['valanceCost']);
        }
        return undefined;
    }
    function getOriginalPriceForType(pricing, productType) {
        switch (productType) {
            case renderCustomValance_1.ProductType.DrapeOnly:
                return getNumberValue(pricing['panelOriginal']);
            case renderCustomValance_1.ProductType.ValanceOnly:
                return getNumberValue(pricing['valanceOriginal']);
            case renderCustomValance_1.ProductType.FullSet:
                return getNumberValue(pricing['fullSetOriginal']);
        }
    }
    function computeDiscount(original, current) {
        if (original <= current) {
            return 0;
        }
        var discount = original - current;
        var discountRate = discount / original;
        return Math.round(discountRate * 100);
    }
    function getCurrentProductType(notNull) {
        var data = priceFormula_1.getAttributesFromForm(true);
        var styleIndex = getNumberValue(data['styleIndex']);
        return styleIndex === 10 ? renderCustomValance_1.ProductType.DrapeOnly :
            (notNull ? getNumberValue(data['productType']) : null);
    }
    function displayPriceInfo(pricing, productType, $add) {
        var price = getPriceForType(pricing, productType);
        var originalPrice = getOriginalPriceForType(pricing, productType);
        var discount = computeDiscount(originalPrice, price);
        var extraDiscountedPricing = priceFormula_1.computeDiscountedPricing({ 'itemCost': price });
        $add.find('#customizePriceQuote').text("$" + Math.floor(price).toFixed(0));
        $add.find('#customizePriceOriginal').text("$" + originalPrice.toFixed(0));
        $add.toggleClass('hidden', false);
        if (discount > 0) {
            $add.find('#customizeDiscount').text("(" + discount + "% off)").toggleClass('hidden', false);
        }
        else {
            $add.find('#customizeDiscount').toggleClass('hidden', true);
        }
        var extraDiscountedPrice = extraDiscountedPricing['itemCost'];
        $add.toggleClass('has-extra-discount', extraDiscountedPrice < price);
        if (extraDiscountedPrice < price) {
            var extraDiscount = computeDiscount(price, extraDiscountedPrice);
            $add.find('#extra_discount_rate').text("Extra " + extraDiscount + "% off").toggleClass('hidden', false);
            $add.find('#extra_discount_price').text("$" + extraDiscountedPrice.toFixed(0)).toggleClass('hidden', false);
        }
        else {
            var $extraDiscount = $add.find('#extra_discount_rate');
            var $extraDiscountedPrice = $add.find('#extra_discount_price');
            if ($extraDiscountedPrice.length === 1 && $extraDiscountedPrice.closest('#design_show_summary').length) {
                $extraDiscountedPrice.closest('tr').toggleClass('hidden', true);
            }
            else {
                $extraDiscount.toggleClass('hidden', true);
                $extraDiscountedPrice.toggleClass('hidden', true);
            }
        }
    }
    exports.displayPriceInfo = displayPriceInfo;
    var sheerFormulaName = 'PF-SHEER-2020-01-01';
    var pillowFormulaName = 'pillowCasePrice2022';
    function calculatePriceIfPossible() {
        var data = priceFormula_1.getAttributesFromForm(true);
        var drapeWidth = getNumberValue(data['width']);
        var drapeHeight = getNumberValue(data['height']);
        var styleIndex = getNumberValue(data['styleIndex']);
        var fabricId = getNumberValue(data['fabricId']);
        var fabricGrade = getNumberValue(data['fabricGrade']);
        data = priceFormula_1.getAttributesFromForm(true, getCurrentProductType());
        data['hasFringe'] = data['fringeColor'] > 0 ? 1 : 0;
        var productType = getNumberValue(data['productType']);
        var $add = $('.customizeAddCart');
        var $publish = $('#publishDesignBook');
        if (fabricId > 0 && drapeWidth !== undefined && drapeHeight !== undefined && styleIndex !== undefined) {
            var formulaName = styleIndexToFormula["s" + styleIndex];
            var formulaNames = formulaName + ";" + sheerFormulaName + ";" + pillowFormulaName;
            priceFormula_1.computeFormulaPricing(formulaApiUrl, formulaNames, data).then(function (pricing) {
                if (pricing['panelWidth']) {
                    number_1.setFieldNumberVal($('input[type="hidden"]#panelWidth'), pricing['panelWidth']);
                }
                displayPriceInfo(pricing, productType, $add);
                $publish.toggleClass('hidden', $add.hasClass('hidden'));
            }, function (e) {
                $add.toggleClass('hidden', true);
                $publish.toggleClass('hidden', $add.hasClass('hidden'));
                console.info("pricing error = " + JSON.stringify(e));
            });
        }
        else {
            $add.toggleClass('hidden', true);
            $publish.toggleClass('hidden', true);
        }
    }
    function syncAddressBar() {
        var data = priceFormula_1.getAttributesFromForm(false, getCurrentProductType());
        addressBar_2.setHashFromData(data);
    }
    exports.syncAddressBar = syncAddressBar;
    function validateNumberThen(next, e) {
        var $field = $(e.currentTarget);
        var id = $field.attr('id');
        if (!e.isTrigger && $field.attr('type') === 'hidden' && !defaultWindowMeasure[id]) {
            return;
        }
        var fieldVal = $field.val();
        var val = number_1.firstNumber(fieldVal * 1);
        var min = number_1.firstNumber($field.data('min') * 1, 1 * $field.attr('min'));
        var max = number_1.firstNumber($field.data('max') * 1, 1 * $field.attr('max'));
        if (!fieldVal) {
            return;
        }
        var $edit = $("*[data-sync=\"" + id + "\"]");
        if ($edit.length === 0) {
            $edit = $("label[for$=\"_" + id + "\"]");
        }
        if (min <= val && val <= max) {
            $edit.toggleClass('err', false);
            $edit.next('.err').remove();
            next(e);
        }
        else {
            var message = "between " + min + " and " + max;
            var $err = $edit.next('.err');
            if (!$err.length) {
                $err = $("<span class='err'></span>").insertAfter($edit);
            }
            $err.text(message);
            $edit.toggleClass('err', true);
        }
    }
    function validateAllMeasurements() {
        $('#panel0 input, #panel0 select, #panel1 input, #panel1 select').each(function (i, field) {
            validateNumberThen((function () { }), { currentTarget: $(field) });
        });
        var valid = hasValidWindowMeasurements();
        if (valid) {
            onWindowMeasureXUpdated(null);
            onWindowMeasureYUpdated(null);
        }
        return valid;
    }
    function missingWindowMeasurements(markError) {
        var isMobile = context_1["default"].isMobile();
        var $panel = $("#panel" + PanelIndex.measurement);
        var missing = isMobile
            ? $panel.find('label[for^="windowSizeEdit_"] span.current').filter(function (i, span) { return !$(span).text(); })
            : $panel.find('input[data-sync]').filter(function (i, input) { return !$(input).val(); });
        if (markError) {
            missing.each(function (i, x) { return (isMobile ? $(x).closest('label') : $(x)).toggleClass('err', true); });
            if (isMobile && missing.length) {
                $(missing[0]).closest('label').click();
            }
        }
        return missing;
    }
    function hasValidWindowMeasurements() {
        var m = getWindowMeasurements();
        return Object.keys(m).reduce(function (f, x) { return f && !!m[x]; }, true);
    }
    var formulaApiUrl = null;
    function selectDefaultSlideSelectBox($panel) {
        var $ul = $panel.find('.slide-select-box ul.asset-picker');
        var $selected = $ul.find('.selected');
        if ($selected.length === 0) {
            var $defSelected = $ul.find('.default-selected');
            $defSelected.toggleClass('selected', true).toggleClass('default-selected', false);
        }
    }
    function toggleInputPanel(e) {
        var $button = $(e.currentTarget);
        var $section = $button.closest('.sub-section');
        var $panel;
        if ($section.length) {
            $panel = $section.parent();
        }
        else {
            $panel = $button.closest('.attribute-panel.collapsed');
            $section = $panel;
        }
        if ($section.length === 0) {
            $panel = $button.closest('.customDesignFabric');
            $panel.find('.show-picker-action').click();
            setPanelIndex(parseFloat($panel.find('.attribute-picker').attr('id').substr(5).replace('_', '.')));
            setUrl();
            return;
        }
        if ($panel.length) {
            var panelId = $panel.attr('id');
            var toExpand = $section.hasClass('collapsed');
            if (toExpand) {
                $section.find('.info-bar button').prev('span').text('');
                var hidePanelId = panelId === 'panel0' ? 'panel1' : 'panel0';
                $("#" + hidePanelId + " .sub-section").toggleClass('expanded', false).toggleClass('collapsed', true);
                $section.toggleClass('expanded', true).toggleClass('collapsed', false);
                var panelIndex = parseInt(panelId.substr(5));
                selectDefaultSlideSelectBox($panel);
                setPanelIndex(panelIndex);
                setUrl();
                renderCustomValance_1.renderPictures(true, styleIndex, panelIndex === PanelIndex.measurement ? renderCustomValance_1.ProductType.WindowOnly : undefined);
                updateDescriptions();
            }
            if (context_1["default"].isMobile()) {
                $panel.toggleClass('bottom-panel', true);
            }
        }
    }
    function syncEditField(e) {
        var $cur = $(e.currentTarget);
        var $target = $("input#" + $cur.data('sync'));
        var val = $cur.val();
        $target.data('decimal', val).val(val).change();
    }
    function currentDefaultWindowMeasure(defVal) {
        var cur = {};
        $.each(defVal, function (k, v) {
            cur[k] = $("#" + k).data('decimal') || v;
        });
        return cur;
    }
    function setSyncEditFromHash() {
        $('input[data-sync], select[data-sync]').each(function (i, edit) {
            var $edit = $(edit);
            var $fld = $("#" + $edit.data('sync'));
            var val = parseFloat($fld.val());
            if (val && val > 0) {
                $edit.val(val).data('decimal', val);
            }
        });
    }
    function setCurtainSize() {
        var sel = $('#useCustomSize').data('decimal');
        var $width = $('#drapeWidth');
        var $height = $('#drapeHeight');
        var width;
        var height;
        if (sel === 0) {
            width = parseInt($('#custom_recommended_width').text());
            height = parseInt($('#custom_recommended_height').text());
            $('#drapeHeight').val();
        }
        else {
            width = $('#custom_drapeWidth').val();
            height = $('#custom_drapeHeight').val();
        }
        if (!isNaN(height)) {
            $height.data('decimal', height).val(height);
        }
        if (!isNaN(width)) {
            $width.data('decimal', width).val(width).change();
        }
    }
    function initCurtainSizePanel() {
        $('#panel1 input:not([type="hidden"]), #panel1 select').change(function () {
            setCurtainSize();
            syncAddressBar();
        });
        $('#useCustomSize').change(function (e) {
            setCurtainSize();
        });
    }
    ;
    function useDefaultWindowSize() {
        analytics_1["default"]('customize', 'defaultWindowSize');
        $('#skipWindowMeasurement').data('decimal', 1);
        $('#skipWindowMeasurement').change();
        Object.keys(defaultWindowMeasure).forEach(function (k) {
            $("#" + k).removeData('decimal').removeAttr('value');
        });
        var curtainWidth = onWindowMeasureXUpdated(null);
        var curtainHeight = onWindowMeasureYUpdated(null);
        $('#custom_recommended_height').text(curtainHeight + " inch");
        $('#custom_recommended_width').text(curtainWidth + " inch");
        setCurtainSize();
        setPanelIndex(PanelIndex.color);
        onSpecChange({ windowSize: true });
        setUrl();
        updateDescriptions();
    }
    function useCustomWindowSize() {
        analytics_1["default"]('customize', 'customWindowSize');
        $('#panel0 input[data-sync], #panel0 select[data-sync]').each(function (i, edit) {
            var $edit = $(edit);
            var val = number_1.extractFieldAsDecimal($edit);
            var $fld = $("#" + $edit.data('sync'));
            if (typeof val === 'number' && !isNaN(val)) {
                number_1.setFieldNumberVal($fld, val);
            }
        });
        onWindowMeasureXUpdated(null);
        onWindowMeasureYUpdated(null);
        number_1.setFieldNumberVal($('#custom_drapeWidth'), idealWidth);
        number_1.setFieldNumberVal($('#custom_drapeHeight'), idealHeight);
    }
    function randomClick(e) {
        var count = e.length;
        if (count >= 1) {
            var index = Math.floor(Math.random() * count);
            e[index].click();
        }
    }
    function onSlotMachine(e) {
        if ($("#spin_style").prop("checked") && (!($("#spin_fabric").prop("checked")) || Math.random() < 0.5)) {
            randomClick($(".customDesignStyle .slide-select li img"));
            return;
        }
        if ($("#spin_fabric").prop("checked")) {
            randomClick($(".customDesignFabric#mainFabricSection .asset-picker img.asset"));
            randomClick($(".Fringe .slide-select li.fringe img"));
        }
    }
    function syncMatchingFabricApplication(setCheckbox, options) {
        var $styleIndex = number_1.extractFieldAsDecimal($('#custom_style_select input'));
        var fringeMask = $('#custom_style_select li.selected').data('fringemask');
        var allowedFringeTags = fringeMask ? fringeMask.split(',') : [];
        var $matchingFabricParts = renderCustomValance_2.styleToMatchingFabricParts[$styleIndex];
        if ($matchingFabricParts == undefined)
            return;
        $('#matchingFabricApplication input').each(function (i, checkbox) {
            var optId = $(checkbox).attr('id');
            var key = optId.substring(12);
            var optVal = options && optId in options ? options[optId] : undefined;
            var $mappedTo = optVal === undefined ? $matchingFabricParts[key] : (optVal === 'true' || (+optVal) > 0);
            var $checkbox = $(checkbox);
            var $box = $checkbox.parent();
            if ($mappedTo === undefined) {
                $box.toggleClass('hidden', true);
                if (setCheckbox) {
                    $checkbox.prop('checked', false);
                }
            }
            else {
                $box.toggleClass('hidden', false);
                if (setCheckbox) {
                    $checkbox.prop('checked', $mappedTo);
                }
            }
        });
        $('li.fringe').each(function (i, item) {
            var $fringe = $(item);
            var tags = $fringe.data('tags').split(',').filter(function (x) { return x.indexOf('fringeStyle_') !== 0; });
            if (tags.length === 0) {
                $fringe.toggleClass('hidden', false);
            }
            else {
                $fringe.toggleClass('hidden', !assetFilter_1.overlaps(tags, allowedFringeTags));
            }
        });
    }
    exports.syncMatchingFabricApplication = syncMatchingFabricApplication;
    function validateFabricGrades() {
        var fabric2Grade = parseInt($('input[data-attribute-name="fabric2Grade"]').val());
        var fabricGrade = parseInt($('input[data-attribute-name="fabricGrade"]').val());
        if (!isNaN(fabric2Grade) && !isNaN(fabricGrade) && fabric2Grade > fabricGrade) {
            $('#second-fabric').prop('checked', false).trigger('change');
            return false;
        }
        return true;
    }
    function validateCurtainSize() {
        return $('input[type="number"][data-check-range]').next('.error.required').length === 0;
    }
    function sync2ndFabricOption(triggerSecondFabric) {
        var data = priceFormula_1.getAttributesFromForm();
        var secondFabricOn = renderCustomValance_1.defaultWithMatchingFabric(data.styleIndex);
        var $secondFabricCheckbox = $('#second-fabric');
        if (secondFabricOn) {
            $secondFabricCheckbox.prop('checked', true);
            if (triggerSecondFabric) {
                $secondFabricCheckbox.trigger('change');
            }
        }
        else {
            $secondFabricCheckbox.removeProp('checked');
        }
    }
    function setMatchingFabric() {
        var _a = priceFormula_1.getAttributesFromForm(), def2ndFabricId = _a.matchingFabricId, fabric2_CodeName = _a.fabric2_CodeName, fabric2Id = _a.fabric2Id, fabricId = _a.fabricId;
        var $secondFabricPicker = $('#panel3-5').find('.asset-picker');
        var matchingFabricId = def2ndFabricId === -1 ? fallbackMatchingFabric_1["default"].fabricId : def2ndFabricId;
        var useMatchingFabricCode = fabric2Id === fabricId ? null : fabric2_CodeName;
        var selected2ndFabric = useMatchingFabricCode || $secondFabricPicker.find("img.asset[data-asset_id=\"" + matchingFabricId + "\"]").attr("codename");
        if (selected2ndFabric) {
            $secondFabricPicker.find("img[codename=\"" + selected2ndFabric + "\"]").click();
        }
        else {
            console.log("no matching fabric found");
        }
    }
    function toggleMatchingFabricSection() {
        var prev = $('#second-fabric:checked').length === 0;
        var cur = !prev;
        $('#matchingFabricSection').toggleClass('hidden', !cur);
        if (cur) {
            setPanelIndex(3.5);
            if (!number_1.extractFieldAsDecimal($('input[data-attribute-name="fabric2Id"]'))) {
                $('#panel3-5').prev().find('.show-picker-action').click();
            }
            var _a = priceFormula_1.getAttributesFromForm(), def2ndFabricId = _a.matchingFabricId, fabric2_CodeName = _a.fabric2_CodeName, fabric2Id = _a.fabric2Id, fabricId = _a.fabricId;
            var $secondFabricPicker = $('#panel3-5').find('.asset-picker');
            if ($secondFabricPicker.length) {
                setMatchingFabric();
            }
            else {
                $('#panel3-5').bind('DOMNodeRemoved', function (e) {
                    var $t = $(e.target);
                    if ($t.hasClass('asset-picker-place')) {
                        setTimeout(setMatchingFabric, 1000);
                    }
                });
            }
        }
        else {
            removeMatchingFabric();
            productImages_1.removeExtraImageForCustomization($('#desktopPreview'), 'fabric2Id');
        }
    }
    exports.toggleMatchingFabricSection = toggleMatchingFabricSection;
    function removeMatchingFabric() {
        number_1.unsetNumberVal($('#matchingFabricSection input[data-attribute-name="fabric2Id"]'));
        number_1.unsetNumberVal($('#matchingFabricSection input[data-attribute-name="fabric2Grade"]'));
        number_1.unsetNumberVal($('#matchingFabricSection input[data-attribute-name="fabric2_CodeName"]'));
        onSpecChange({ matchingFabric: true });
    }
    exports.removeMatchingFabric = removeMatchingFabric;
    function bindSizeSelect() {
        var $page = $('.product-details-info');
        var box = $('.wallCanvas')[0];
        var handler = selectSpinner_1.layoutSpinner($page, box);
        $page.find('select').on('focus', handler.focus).on('blur', handler.blur);
    }
    var headerHeight = 102;
    function hidePageHeader() {
        var $body = $('body.env-phone');
        if (!$body.length || $body.hasClass('hide-header')) {
            return;
        }
        var $page = $('.product-details-info');
        var height = $page.height();
        if (height < 750) {
            $page.height(height + headerHeight);
            $('body.env-phone').toggleClass('hide-header', true);
        }
    }
    function showPageHeader() {
        var $body = $('body.env-phone.hide-header');
        if ($body.length) {
            var $page = $('.product-details-info');
            $page.height(window.innerHeight - headerHeight);
            $body.toggleClass('hide-header', false);
        }
    }
    function handleSheerChange() {
        var data = priceFormula_1.getAttributesFromForm(false);
        var fabricGrade = data.sheerGrade, width = data.width, height = data.height;
        var name = sheerFormulaName;
        if (fabricGrade * 1) {
            $.post('/plugins/Catalog.FormulaService/Test/0', { fabricGrade: fabricGrade, width: width, height: height, name: name, pocketSize: 1, id: 0 }).then(function (price) {
                console.log("price is " + JSON.stringify(price, null, 2));
            });
        }
        else {
        }
    }
    exports.handleSheerChange = handleSheerChange;
    function handleSizeEdit(evt) {
        evt.preventDefault();
        evt.stopPropagation();
        var targetId = $(evt.currentTarget).data('open-panel');
        var $target = $("#" + targetId);
        var panelIndex = getPanelIndex();
        var prevPanel = panelIndex;
        if (panelIndex == PanelIndex.LAST) {
            prevPanel = panelOrder[0];
        }
        var $prevPanel = $("#panle" + prevPanel);
        setPanelIndex(targetId.substr(5));
        if (!context_1["default"].isMobile()) {
            $target.find('.info-bar button').click();
            if (prevPanel != PanelIndex.size) {
                $prevPanel.find('.sub-section').toggleClass('expanded', false).toggleClass('collpased', true);
            }
        }
        $target[0].scrollIntoView();
    }
    exports.handleSizeEdit = handleSizeEdit;
    function handleProductTypeChange(triggerSecondFabric) {
        var productType = $("input[name='product_attribute_type']").val();
        var $productStyleSelect = $("#custom_style_select");
        var $fringeSelect = $("#custom_fringeSelect");
        var $secondFabricCheckBox = $("#second-fabric");
        $productStyleSelect.toggleClass("disabled", productType == 2);
        $fringeSelect.toggleClass("disabled", productType == 2);
        if (productType == 2) {
            $secondFabricCheckBox.prop('disabled', 'disabled');
        }
        else {
            $secondFabricCheckBox.removeProp('disabled');
        }
        sync2ndFabricOption(triggerSecondFabric);
    }
    exports.handleProductTypeChange = handleProductTypeChange;
    function onMeasureAttributeChange(e) {
        var _a, _b;
        var cur = e.currentTarget;
        var $cur = $(cur);
        var curId = $cur.attr('id');
        var tag = cur.tagName.toUpperCase();
        var changedKey = $cur.data('attributeName') || curId || $cur.attr('name');
        if (curId === 'skipWindowMeasurement') {
            updateDescriptions();
            return;
        }
        if (curId === 'drapeWidth' || curId === 'drapeHeight') {
            validateNumberThen(onSpecChange.bind(null, (_a = {}, _a[changedKey] = true, _a)), e);
        }
        else {
            if (tag === 'SELECT' || tag === 'INPUT' && $cur.attr('type').toLowerCase() != 'hidden') {
                if ($cur.data('decimal') != $cur.val()) {
                    $cur.data('decimal', $cur.val());
                }
            }
            onSpecChange((_b = {}, _b[changedKey] = $cur.val(), _b));
        }
    }
    function initializeCustomDesigner(postUrl) {
        formulaApiUrl = postUrl;
        if (context_1["default"].isMobile()) {
            var $page = $('.product-details-info');
            $page.height(window.innerHeight - headerHeight);
        }
        bindSizeSelect();
        $(function () {
            $('#fillDefaultWindowMeasurements').click(useDefaultWindowSize);
            $('#measure_help').click(function (e) {
                e.preventDefault();
                $('.measure-help').dialog('show');
            });
            $('.measure-help').appendTo('body');
            $('#recommendSize').click(function (e) {
                e.preventDefault();
                e.stopPropagation();
                analytics_1["default"]('customize', 'recommendSize');
                onWindowMeasureXUpdated(null);
                onWindowMeasureYUpdated(null);
                validateAllMeasurements();
                $('#drapeWidth').change();
                onSpecChange({ recommendSize: true });
            });
            $('#windowWidth, #leftMargin, #rightMargin').change(validateNumberThen.bind(null, onWindowMeasureXUpdated));
            $('#windowHeight, #topMargin, #bottomMargin').change(validateNumberThen.bind(null, onWindowMeasureYUpdated));
            $('#panel0-next').click(function (e) {
                $('#drapeHeight').change();
                $('#useCustomSize').data('decimal', 0).val(0).change();
                $('#panel1 .radio-option[data-decimal="0"]').toggleClass('selected', true);
                $('#panel1 .radio-option[data-decimal="1"]').toggleClass('selected', false);
                setCurtainSize();
            });
            $('.next-section').click(onClickNext);
            $('.prev-section').click(onClickPrev);
            $('.advanced-section').click(onClickAdvanced);
            initCurtainSizePanel();
            $('#slotMachine').click(onSlotMachine);
            $('#fabric2_for_valance').change(function (s) {
                var $checked = $('#fabric2_for_valance').attr('checked') == 'checked';
                $('#fabric2_for_swags').prop('checked', $checked);
                $('#fabric2_for_fans').prop('checked', $checked);
                $('#fabric2_for_rodPocket').prop('checked', $checked);
                $('#fabric2_for_sideTails').prop('checked', $checked);
                $('#fabric2_for_midTails').prop('checked', $checked);
                onSpecChange({ fabric2_for_valance: true });
            });
            $('input[name="2ndFabricColor"]').change(function (e) {
                var cur = e.currentTarget;
                var $cur = $(cur);
                var curValue = $cur.val();
                if (curValue === 'none') {
                    removeMatchingFabric();
                }
                else {
                    var curSelector = '#matchingFabricSection .asset[codename="' + curValue + '"]';
                    $(curSelector).click();
                }
            });
            addressBar_1.setAttributesFromHash();
            curtainSizeSpec_1.initialize($('div[data-sizeSpec]'), $('input[name="product_attribute_type"]'), $('input[name="window_attribute_type"]'));
            $('.attributes select, input[data-attribute-id]').change(onMeasureAttributeChange);
            setPanelIndex(getPanelIndex());
            if (!$('#custom_style_select input').val() || $('#custom_style_select input').val() == "") {
                syncMatchingFabricApplication(false);
            }
            else {
                var attrs = addressBar_1.queryToAttributes();
                var matchingAttrs = addressBar_1.pickAttributes(attrs, function (n) { return n.startsWith('fabric2_for_'); });
                syncMatchingFabricApplication(true, matchingAttrs);
            }
            setSyncEditFromHash();
            var $prodType = $('input[name="product_attribute_type"]');
            var prodType = $prodType.data('decimal') === null ? renderCustomValance_1.ProductType.WindowOnly : number_1.firstNumber($prodType.data('decimal') * 1, renderCustomValance_1.ProductType.WindowOnly);
            renderCustomValance_1.renderPictures(true, styleIndex, prodType).then(function () {
                $('#custom_sheerSelect input[type="hidden"]').trigger('change');
            });
            assetPicker_1.setupProductPickerAction('.show-picker-action');
            $('button[name="addtocartbutton"]').click(addCustomOrderToCart);
            $('button#publishDesignBook, #shareProduct').click(publishDesignBook);
            if ($('#skipWindowMeasurement').data('decimal') == 1) {
                $('#fillDefaultWindowMeasurements').click();
            }
            $('.info-bar button').click(toggleInputPanel);
            $('input[data-sync],select[data-sync]').change(syncEditField);
            calculatePriceIfPossible();
            setCurtainSize();
            setRecommendedText();
            validateAllMeasurements();
            updateDescriptions();
            handleProductTypeChange(true);
            if (context_1["default"].isMobile()) {
                var panelIndex = getPanelIndex();
                if (panelIndex !== PanelIndex.measurement) {
                    $("#panel" + PanelIndex.measurement).toggleClass('bottom-panel', false);
                    setPanelIndex(panelIndex);
                }
            }
            renderCustomValance_1.loadPartImage("ClassicSwags/ClassicSwag-SKETCH00.png");
            renderCustomValance_1.loadPartImage("RodPocket/RodPocket-SKETCH00.png");
            renderCustomValance_1.loadPartImage("WideTailsLeft/WideTail-Left-SKETCH00.png");
            renderCustomValance_1.loadPartImage("PanelRodPocket/Panel-RodPocket-Tied-SKETCH00.png");
        });
    }
    exports.initializeCustomDesigner = initializeCustomDesigner;
});



//////////////////
// WEBPACK FOOTER
// ./Scripts/built/customDesign.js
// module id = 42
// module chunks = 0